import { render, staticRenderFns } from "./CoursewareErrorBlock.vue?vue&type=template&id=29eb24a8&"
import script from "./CoursewareErrorBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareErrorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports